// Service Type Field Requirements Mapping
const serviceTypeFieldRequirements = {
  7: { // Export Cargo
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'origin_pin', 'relocation_date',
      'destination_country', 'destination_state', 'destination_city',
      'mode_of_transport', 'delivery_type', 'origin_city_code',
      'destination_city_code', 'airline_id',
      'number_of_pets', 'pet_type', 'pet_breed',
       'crate_size'
    ],
    optional: [
      'origin_contact_person', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'baggage_type', 'flight_number',
      'departure_time', 'arrival_time', 'airlines_rate',
      'pet_dob', 'pet_age', 'pet_length', 'pet_width', 'pet_height',
      'origin_address', 'pet_weight', 'origin_contact_no', 'pet_name',
      'container_length', 'awb_number'
    ]
  },
  19: { // Export Baggage
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'origin_pin', 'relocation_date',
      'destination_country', 'destination_state', 'destination_city',
      'mode_of_transport', 'delivery_type', 'origin_city_code',
      'destination_city_code', 'airline_id',
      'number_of_pets', 'pet_type', 'pet_breed',
       'crate_size', 'pet_weight', 'baggage_type'
    ],
    optional: [
      'origin_contact_person', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'flight_number',
      'departure_time', 'arrival_time', 'airlines_rate',
      'pet_dob', 'pet_age', 'pet_length', 'pet_width', 'pet_height',
      'chargeable_wt', 'origin_address', 'origin_contact_no', 'pet_name', 'container_length'
    ]
  },
  8: { // Export NoC
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country',
      'destination_state', 'destination_city', 'destination_city_code',
      'number_of_pets', 'pet_type', 'pet_breed', 'origin_pin', 'airline_id'
    ],
    optional: [
      'origin_address', 'origin_contact_person', 'origin_contact_no',
      'destination_address', 'destination_pin', 'destination_contact_person',
      'destination_contact_no', 'available_slot', 'pet_dob', 'pet_age',
      'pet_weight', 'pet_length', 'container_length', 'pet_width',
      'pet_height', 'crate_size', 'chargeable_wt', 'pet_name',
    ]
  },
  9: { // Import Cargo
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'destination_pin', 'mode_of_transport',
      'delivery_type', 'origin_city_code', 'destination_city_code',
      'number_of_pets', 'pet_type', 'pet_breed',
      'crate_size'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_contact_person',
      'destination_contact_no', 'available_slot', 'baggage_type',
      'flight_number', 'departure_time', 'arrival_time', 'airline_id',
      'pet_dob', 'pet_age', 'pet_length', 'pet_width', 'pet_height',
      'chargeable_wt', 'pet_weight', 'pet_name', 'container_length'
    ]
  },
  10: { // Import NoC
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'pet_dob', 'pet_age', 'pet_weight',
      'pet_length', 'container_length', 'pet_width', 'pet_height',
      'crate_size', 'chargeable_wt', 'pet_name'
    ]
  },
  11: { // Titre Test (EU)
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'pet_dob', 'pet_age', 'pet_weight',
      'pet_length', 'container_length', 'pet_width', 'pet_height',
      'crate_size', 'chargeable_wt', 'pet_name'
    ]
  },
  12: { // Titre Test (India)
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'pet_dob', 'pet_age', 'pet_weight',
      'pet_length', 'container_length', 'pet_width', 'pet_height',
      'crate_size', 'chargeable_wt', 'pet_name'
    ]
  },
  13: { // Microchip (Dog)
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'pet_dob', 'pet_age', 'pet_weight',
      'pet_length', 'container_length', 'pet_width', 'pet_height',
      'crate_size', 'chargeable_wt',  'pet_name'
    ]
  },
  14: { // Microchip (Cat)
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'pet_dob', 'pet_age', 'pet_weight',
      'pet_length', 'container_length', 'pet_width', 'pet_height',
      'crate_size', 'chargeable_wt', 'pet_name'
    ]
  },
  15: { // Cage (All Size)
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'relocation_date', 'destination_country', 'destination_state',
      'destination_city', 'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_address', 'origin_pin', 'origin_contact_person',
      'origin_contact_no', 'destination_address', 'destination_pin',
      'destination_contact_person', 'destination_contact_no',
      'available_slot', 'pet_dob', 'pet_age', 'pet_weight',
      'pet_length', 'container_length', 'pet_width', 'pet_height',
      'crate_size', 'chargeable_wt', 'pet_name'
    ]
  },
  16: { // Domestic Air
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'origin_pin', 'relocation_date',
      'destination_country', 'destination_state', 'destination_city',
      'destination_pin', 'mode_of_transport', 'delivery_type',
      'origin_city_code', 'destination_city_code',
      'number_of_pets', 'crate_size', 'chargeable_wt', 'pet_type', 'pet_breed',

    ],
    optional: [
      'origin_address', 'origin_contact_person',
      'origin_contact_no', 'destination_address',
      'destination_contact_person', 'destination_contact_no', 'available_slot',
      'airline_id', 'flight_number', 'departure_time', 'arrival_time',
      'pet_age', 'pet_length', 'pet_width', 'pet_height', 'pet_dob',
      'awb_number', 'baggage_type', 'pet_weight', 'container_length', 'pet_name'
    ]
  },
  17: { // Domestic Train
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'origin_pin', 'relocation_date', 'destination_pin',
      'destination_country', 'destination_state', 'destination_city',
      'mode_of_transport', 'delivery_type',
      'origin_city_code', 'destination_city_code',
      'train_name_number', 'number_of_pets', 'pet_type',
      'pet_breed'
    ],
    optional: [
      'origin_contact_no', 'destination_address', 'origin_address', 'origin_contact_person',
      'destination_contact_person', 'destination_contact_no', 'available_slot',
      'pet_dob', 'pet_age', 'pet_weight', 'pet_length',
      'container_length', 'pet_width', 'pet_height', 'crate_size',
      'chargeable_wt', 'price',  'pet_name', 'awb_number'
    ]
  },
  18: { // Domestic Road
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 'relocation_purpose',
      'where_did_you_find_us', 'origin_country', 'origin_state', 'origin_city',
      'origin_pin', 'destination_pin', 'relocation_date',
      'destination_country', 'destination_state', 'destination_city',
      'mode_of_transport', 'delivery_type',
      'number_of_pets', 'pet_type', 'pet_breed'
    ],
    optional: [
      'origin_contact_no', 'destination_address', 'destination_contact_person',
      'destination_contact_no', 'available_slot',
      'pet_dob', 'pet_age', 'pet_weight', 'pet_length',
      'container_length', 'pet_width', 'pet_height', 'crate_size',
      'chargeable_wt', 'origin_address', 'origin_contact_person', 'pet_name'
    ]
  },
  20: { // NOTA
    required: [
      'first_name', 'gender', 'email', 'mobile_no', 
      'where_did_you_find_us'
    ],
    optional: [
      'origin_contact_no', 'destination_address', 'destination_contact_person',
      'destination_contact_no', 'available_slot', 'relocation_purpose',
      'pet_dob', 'pet_age', 'pet_weight', 'pet_length',
      'container_length', 'pet_width', 'pet_height', 'crate_size',
      'chargeable_wt', 'origin_address', 'origin_contact_person', 'pet_name',
      , 'origin_country', 'origin_state', 'origin_city',
      'origin_pin', 'destination_pin', 'relocation_date',
      'destination_country', 'destination_state', 'destination_city',
      'mode_of_transport', 'delivery_type',
      'number_of_pets', 'pet_type', 'pet_breed'
    ]
  }

};

/**
 * Validates form data based on service type
 * @param {Object} formData - The form data object containing all field values
 * @param {number|string} serviceType - The service type ID
 * @returns {Object} - Returns validation result with isValid flag and errors array
 */
const validateFormByServiceType = (formData, serviceType) => {
  const errors = [];
  const serviceTypeId = parseInt(serviceType);

  // Check if service type exists in our mapping
  if (!serviceTypeFieldRequirements[serviceTypeId]) {
    return {
      isValid: false,
      errors: ['Invalid service type selected']
    };
  }

  const { required } = serviceTypeFieldRequirements[serviceTypeId];

  // Field display names for better error messages
  const fieldLabels = {
    first_name: 'Full Name',
    gender: 'Gender',
    email: 'Email ID',
    mobile_no: 'Mobile Number',
    relocation_purpose: 'Purpose of Relocation',
    where_did_you_find_us: 'Find Where',
    origin_country: 'From Country',
    origin_state: 'From State',
    origin_city: 'From City',
    origin_address: 'Pickup Address',
    origin_pin: 'Origin Pincode',
    origin_contact_person: 'Sender Name',
    origin_contact_no: 'Sender Contact Number',
    relocation_date: 'Relocation Date',
    available_slot: 'Available Slots',
    destination_country: 'To Country',
    destination_state: 'To State',
    destination_city: 'To City',
    destination_address: 'Drop Address',
    destination_pin: 'Destination Pincode',
    destination_contact_person: 'Receiver Name',
    destination_contact_no: 'Receiver Contact Number',
    mode_of_transport: 'Mode Of Transportation',
    delivery_type: 'Delivery Type',
    origin_city_code: 'From City Code/Airport',
    destination_city_code: 'To City Code/Airport',
    airline_id: 'Airline Name',
    flight_number: 'Flight Number',
    departure_time: 'Departure Time',
    arrival_time: 'Arrival Time',
    awb_number: 'AWB/Shipment Reference Number',
    baggage_type: 'Baggage Type',
    airlines_rate: 'Request Rate for Airlines',
    train_name_number: 'Train Name And Number',
    price: 'Price',
    number_of_pets: 'Number of Pets',
    pet_type: 'Pet Type',
    pet_breed: 'Pet Breed',
    pet_dob: 'Pet DOB',
    pet_age: 'Pet Age',
    pet_weight: 'Pet Weight',
    pet_length: 'Pet Length (A)',
    container_length: 'Pet Height from ground to elbow joint (B)',
    pet_width: 'Pet Width (C)',
    pet_height: 'Pet Height (D)',
    pet_name: 'Pet Name',
    crate_size: 'Recommended Crate Size',
    chargeable_wt: 'Applicable Chargeable Weight'
  };

  // Validate required fields
  required.forEach(fieldName => {
    const value = formData[fieldName];
    const isEmpty = value === null ||
      value === undefined ||
      value === '' ||
      value === '0' ||
      value === 0 ||
      (typeof value === 'string' && value.trim() === '');

    if (isEmpty) {
      const label = fieldLabels[fieldName] || fieldName;
      errors.push(`${label} is required`);
    }
  });

  // Additional validation for specific field types
  if (required.includes('email') && formData.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      errors.push('Please enter a valid email address');
    }
  }

  // if (required.includes('mobile_no') && formData.mobile_no) {
  //   const mobileRegex = /^[0-9]{10}$/;
  //   if (!mobileRegex.test(formData.mobile_no.replace(/\s/g, ''))) {
  //     errors.push('Please enter a valid 10-digit mobile number');
  //   }
  // }

  return {
    isValid: errors.length === 0,
    errors: errors,
    requiredFields: required
  };
};

/**
 * Checks if a specific field is required for the given service type
 * @param {string} fieldName - The field name to check
 * @param {number|string} serviceType - The service type ID
 * @returns {boolean} - Returns true if field is required, false otherwise
 */
const isFieldRequired = (fieldName, serviceType) => {
  const serviceTypeId = parseInt(serviceType);

  if (!serviceTypeFieldRequirements[serviceTypeId]) {
    return false;
  }

  return serviceTypeFieldRequirements[serviceTypeId].required.includes(fieldName);
};

/**
 * Gets all required fields for a specific service type
 * @param {number|string} serviceType - The service type ID
 * @returns {Array} - Returns array of required field names
 */
const getRequiredFields = (serviceType) => {
  const serviceTypeId = parseInt(serviceType);

  if (!serviceTypeFieldRequirements[serviceTypeId]) {
    return [];
  }

  return serviceTypeFieldRequirements[serviceTypeId].required;
};

/**
 * Adds visual indicators to required fields in the form
 * @param {number|string} serviceType - The service type ID
 */
const markRequiredFields = (serviceType) => {
  const requiredFields = getRequiredFields(serviceType);

  // Remove all existing required markers
  document.querySelectorAll('.required-marker').forEach(el => el.remove());

  // Add required markers to required fields
  requiredFields.forEach(fieldName => {
    const input = document.querySelector(`[name="${fieldName}"]`);
    if (input) {
      const label = input.closest('tr')?.querySelector('th span');
      if (label && !label.querySelector('.required-marker')) {
        const marker = document.createElement('span');
        marker.className = 'required-marker';
        marker.style.color = 'red';
        marker.textContent = ' *';
        label.appendChild(marker);
      }
    }
  });
};

// Export functions for use in your component
export {
  validateFormByServiceType,
  isFieldRequired,
  getRequiredFields,
  markRequiredFields,
  serviceTypeFieldRequirements
};